// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__fnJ0M","footer__menuRow":"footer_footer__menuRow__8ZJrd","footer__copyright":"footer_footer__copyright__goFYv"};